import { Component, OnInit } from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {NotificationsService} from '../../../services/notifications.service';
import {ToastaService} from 'ngx-toasta';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {DialogService} from 'primeng/dynamicdialog';
import {CommonComponent} from '../../shared/common/common.component';
import {ApplicationService} from '../../../services/application.service';
import {Application} from '../../../domain/onBoarding/application';
import {ConfigurationService} from '../../../services/configuration.service';
interface IValidation {
  id: number;
  name: string;
  agentParams: {agentMode: null };
}
@Component({
  selector: 'app-add-referrer-screen',
  templateUrl: './add-referrer-screen.component.html',
  styleUrls: ['./add-referrer-screen.component.scss']
})
export class AddReferrerScreenComponent extends CommonComponent implements OnInit {
  application: Application;
  // Variables to add broker
  validation: IValidation | any;
  // Variables to control the dialogs
  displayConfirm =  false;
  displayContinue = false;
  displayPrivacyModal = true;
  displayInvalidCode = false;

  constructor(
    protected modalService: NgbModal,
    protected notificationsService: NotificationsService,
    protected toastService: ToastaService,
    protected router: Router,
    public translate: TranslateService,
    protected dialogService: DialogService,
    private applicationService: ApplicationService,
    public configurationService: ConfigurationService
  ) {
    super(modalService, notificationsService, toastService, router, translate, dialogService);
    this.application = applicationService.application;
  }

  ngOnInit(): void {
    if (!this.application || !this.application.editing) {
      this.router.navigate(['/onboarding/']);
      return;
    }
    if (!this.configurationService.application.enablePrivacyAct){
      this.displayPrivacyModal = false;
    }
    if (this.application.invalidReferredCode){
      this.displayInvalidCode = true;
    }
    if (this.application.hasReferredCode == null){
      this.application.hasReferredCode = true;
    }
  }
  verifyAgentCode() {
    if (this.application.brokerCode.length > 0){
      this.loadingModalOn();
      this.applicationService.getCodeValidation(this.application.brokerCode).subscribe(
        response => {
          this.validation = response;
          this.displayConfirm = true;
          this.loadingModalOff();
        },
        () => {
          this.loadingModalOff();
          this.displayInvalidCode = true;
        }
      );
    } else {
      this.application.body.altairParentAgentId = null;
      this.displayContinue = true;
    }
  }
  confirmBroker(){
    this.application.body.altairParentAgentId = this.validation.id;
    this.application.body.agentMode = this.validation?.agentParams?.agentMode || null;
    this.nextPage();
  }
  continueProcess(){
    this.nextPage();
  }
  verifyProcess(){
    if (this.application.brokerCode !== null && this.application.brokerCode?.length > 0) {
      this.verifyAgentCode();
      this.displayContinue = false;
    } else {
      this.application.body.altairParentAgentId = null;
      this.displayContinue = true;
    }
  }
  nextPage(){
    if (this.configurationService.application.sendBrokerScreenToEnd){
      this.loadingModalOn();
      this.applicationService.setApplication(true).subscribe(
        (response: any) => {
          this.application.body.status = response.status;
          this.application.body.applicationHash = response.applicationHash;
          if (!this.application.body.applicationId) {
            this.application.body.applicationId = response.applicationId;
          }
          this.loadingModalOff();
          this.router.navigate(['/onboarding/end']);
        },
        error => {
          this.loadingModalOff();
          this.msgError(error);
        }
      );
    } else {
      this.router.navigate(['/onboarding/contactData']);
    }
  }
  onBack(){
    this.router.navigate(['/onboarding/contracts']);
  }
}
